var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M395.901,7.287H116.099C56.003,7.287,7.286,56.004,7.286,116.1v279.803 c0,60.095,48.717,108.812,108.812,108.812h279.803c60.095,0,108.812-48.717,108.812-108.812V116.1 C504.714,56.004,455.997,7.287,395.901,7.287z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.286,
    y: 338.901,
    style: {
      fill: "#ED1F34"
    },
    width: 497.43,
    height: 55.26
  }), /*#__PURE__*/React.createElement("rect", {
    x: 225.79,
    y: 228.361,
    style: {
      fill: "#ED1F34"
    },
    width: 278.92,
    height: 55.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.17,
    y: 117.831,
    style: {
      fill: "#ED1F34"
    },
    width: 268.55,
    height: 55.26
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1F34"
    },
    d: "M116.099,504.715h279.803c40.628,0,76.05-22.27,94.739-55.264H21.36 C40.049,482.445,75.471,504.715,116.099,504.715z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1F34"
    },
    d: "M490.64,62.552c-18.689-32.995-54.111-55.264-94.739-55.264H225.79v55.264H490.64z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#164FCE"
    },
    d: "M335.041,7.287H116.099C56.003,7.287,7.286,56.004,7.286,116.1v167.541h327.755L335.041,7.287 L335.041,7.287z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 72.55,
    cy: 217.091,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 121.86,
    cy: 217.091,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 171.16,
    cy: 217.091,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 220.47,
    cy: 217.091,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 269.77,
    cy: 217.091,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 47.902,
    cy: 240.971,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 97.21,
    cy: 240.971,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 146.51,
    cy: 240.971,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 195.82,
    cy: 240.971,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 245.12,
    cy: 240.971,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 294.43,
    cy: 240.971,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 47.902,
    cy: 193.221,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 97.21,
    cy: 193.221,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 146.51,
    cy: 193.221,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 195.82,
    cy: 193.221,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 245.12,
    cy: 193.221,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 294.43,
    cy: 193.221,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 72.55,
    cy: 169.341,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 121.86,
    cy: 169.341,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 171.16,
    cy: 169.341,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 220.47,
    cy: 169.341,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 269.77,
    cy: 169.341,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 47.902,
    cy: 145.461,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 97.21,
    cy: 145.461,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 146.51,
    cy: 145.461,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 195.82,
    cy: 145.461,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 245.12,
    cy: 145.461,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 294.43,
    cy: 145.461,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 72.55,
    cy: 121.591,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 121.86,
    cy: 121.591,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 171.16,
    cy: 121.591,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 220.47,
    cy: 121.591,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 269.77,
    cy: 121.591,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 47.902,
    cy: 97.711,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 97.21,
    cy: 97.711,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 146.51,
    cy: 97.711,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 195.82,
    cy: 97.711,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 245.12,
    cy: 97.711,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 294.43,
    cy: 97.711,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 72.55,
    cy: 73.835,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 121.86,
    cy: 73.835,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 171.16,
    cy: 73.835,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 220.47,
    cy: 73.835,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 269.77,
    cy: 73.835,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 47.902,
    cy: 49.958,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 97.21,
    cy: 49.958,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 146.51,
    cy: 49.958,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 195.82,
    cy: 49.958,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 245.12,
    cy: 49.958,
    r: 8.953
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 294.43,
    cy: 49.958,
    r: 8.953
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M497.341,59.688c-0.199-0.465-0.447-0.902-0.734-1.311C476.551,23.521,438.921,0.001,395.901,0.001H116.099 C52.082,0.001,0,52.083,0,116.1v279.803c0,20.462,5.328,39.7,14.659,56.412c0.199,0.464,0.447,0.902,0.734,1.311 C35.449,488.481,73.079,512,116.099,512h279.803c43.02,0,80.65-23.52,100.706-58.376c0.287-0.409,0.535-0.846,0.734-1.311 c9.331-16.712,14.659-35.95,14.659-56.412V116.1C512,95.638,506.672,76.4,497.341,59.688z M438.39,386.883 c-4.024,0-7.286,3.262-7.286,7.287s3.262,7.286,7.286,7.286h58.883c-0.791,14.595-4.676,28.38-11.013,40.708H25.74 c-6.337-12.328-10.222-26.113-11.013-40.708h390.501c4.024,0,7.286-3.262,7.286-7.286c0-4.025-3.262-7.287-7.286-7.287H14.573 v-40.692h482.854v40.692L438.39,386.883L438.39,386.883z M497.273,110.546H342.328V69.838H486.26 C492.597,82.166,496.482,95.951,497.273,110.546z M389.101,180.383h108.326v40.691H342.328v-40.691h19.156 c4.024,0,7.286-3.262,7.286-7.287c0-4.025-3.262-7.286-7.286-7.286h-19.156v-40.692h155.099v40.692H389.101 c-4.024,0-7.287,3.262-7.287,7.286C381.814,177.121,385.076,180.383,389.101,180.383z M342.328,235.647h155.099v40.708H342.328 V235.647z M497.427,290.928v40.691H14.573v-40.691H497.427z M477.132,55.265H342.328V14.574h53.574 C429.082,14.574,458.594,30.575,477.132,55.265z M116.099,14.574h211.656v261.781H14.573V116.1 C14.573,60.119,60.117,14.574,116.099,14.574z M395.901,497.428H116.099c-33.181,0-62.693-16.001-81.231-40.691h442.264 C458.594,481.427,429.082,497.428,395.901,497.428z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.7d1da85de0f5d90b2a9d99b91d37c15d.svg";
export { ForwardRef as ReactComponent };